import * as React from 'react';
import styled from '@emotion/styled';
import { observer } from 'src/utils/mobx-react';

interface PropsType {
    className?: string;
    onClick?: () => void;
}

const SvgElement = styled('svg', { label: 'SvgElement' })`
    height: auto;
`;

export const TennisIcon = observer('TennisIcon', ({ className, onClick }: PropsType): JSX.Element => {
    return (
        <SvgElement
            xmlns='http://www.w3.org/2000/svg'
            width='16'
            height='16'
            viewBox='0 0 16 16'
            fill='none'
            className={className}
            onClick={onClick}
        >
            <mask
                id='tennisMask'
                width='14'
                height='16'
                x='1'
                y='0'
                maskUnits='userSpaceOnUse'
                style={{ maskType: 'alpha' }}
            >
                <path
                    fill='#142448'
                    d='m2.283 13.456-.95-.934L4.067 9.79q.516-.516.708-1.292.192-.774.192-2.375 0-.966.433-1.9T6.633 2.49Q8.15.973 9.983.772 11.817.572 13 1.79q1.2 1.2 1 3.033-.2 1.834-1.7 3.334a6 6 0 0 1-1.733 1.233 4.5 4.5 0 0 1-1.9.433q-1.617 0-2.367.184-.75.183-1.283.716zm4.584-5.567q.783.766 2.116.567 1.335-.2 2.384-1.25 1.066-1.067 1.275-2.392t-.575-2.075q-.8-.8-2.092-.6T7.6 3.406Q6.55 4.456 6.325 5.78q-.226 1.325.542 2.108M12 15.456a2.57 2.57 0 0 1-1.883-.784 2.57 2.57 0 0 1-.784-1.883q0-1.1.784-1.883A2.57 2.57 0 0 1 12 10.122q1.1 0 1.883.784.784.783.784 1.883t-.784 1.883a2.57 2.57 0 0 1-1.883.784'
                />
            </mask>
            <g mask='url(#tennisMask)'>
                <path
                    fill='#0b1627'
                    fillOpacity='.64'
                    d='M0 0h16v16H0z'
                />
            </g>
        </SvgElement>
    );
});
